var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-bottom-sheet",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.showCookie,
        callback: function ($$v) {
          _vm.showCookie = $$v
        },
        expression: "showCookie",
      },
    },
    [
      _c(
        "v-sheet",
        {
          staticClass: "text-left transparent",
          attrs: { color: "transparent" },
        },
        [
          _c("div", { attrs: { id: "cookie-consent-container" } }, [
            _c(
              "div",
              { staticClass: "cookie-consent-text" },
              [
                _c(
                  "v-container",
                  { attrs: { "full-width": "" } },
                  [
                    _c(
                      "v-row",
                      { attrs: { align: "center", justify: "center" } },
                      [
                        _c("v-col", { attrs: { cols: "12", md: "10" } }, [
                          _c(
                            "h3",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("lieferluziApp.cookie-consent.title")
                                ),
                              },
                            },
                            [_vm._v("Cookie Usage")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("lieferluziApp.cookie-consent.text")
                                ),
                              },
                            },
                            [_vm._v("We use Cookies")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "2" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "brown darken-4 white--text",
                                attrs: { rounded: "", block: "" },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "lieferluziApp.cookie-consent.button"
                                    )
                                  ),
                                },
                                on: { click: _vm.setCookieAndClose },
                              },
                              [
                                _vm._v(
                                  "\n                Accept\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "brown darken-4 white--text mt-5",
                                attrs: { rounded: "", block: "" },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "lieferluziApp.cookie-consent.reject"
                                    )
                                  ),
                                },
                                on: { click: _vm.rejectCookieAndClose },
                              },
                              [
                                _vm._v(
                                  "\n                Accept\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.$vuetify.breakpoint.mdAndUp
              ? _c("div", { staticClass: "cookie-image" }, [
                  _c("img", { attrs: { src: "/content/images/cookie.png" } }),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }